import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { AnimatePresence, motion } from 'framer-motion'
import { Bed, Phone, Plus, Scissors as ScissorsIcon } from 'lucide-react'

import { Button } from '@/shared/ui/button'

type FloatingActionButtonProps = {
    userId: string
}

export const FloatingActionButton = ({ userId }: FloatingActionButtonProps) => {
    const navigate = useNavigate()
    const [isOpen, setIsOpen] = useState(false)

    const handleHotelReservation = () => {
        setIsOpen(false)
        navigate(`/booking?userId=${userId}`)
    }

    const handleGroomingReservation = () => {
        setIsOpen(false)
        navigate(`/peluqueria-booking?userId=${userId}`)
    }

    const handleCall = () => {
        window.location.href = 'tel:+34+34666777888'
    }

    return (
        <div className='fixed bottom-6 right-6 z-50 sm:bottom-8 sm:right-8'>
            <AnimatePresence>
                {isOpen && (
                    <>
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            className='fixed inset-0 bg-black/20'
                            onClick={() => setIsOpen(false)}
                        />
                        <motion.div
                            initial={{ scale: 0, opacity: 0 }}
                            animate={{
                                scale: 1,
                                opacity: 1,
                                x: -70,
                                y: -70,
                            }}
                            exit={{ scale: 0, opacity: 0 }}
                            transition={{ duration: 0.2 }}
                            className='absolute bottom-6 right-6 sm:bottom-8 sm:right-8'
                        >
                            <Button
                                size='lg'
                                className='h-14 w-14 rounded-full bg-blue-500 p-0 shadow-lg hover:bg-blue-600 sm:h-16 sm:w-16'
                                onClick={handleHotelReservation}
                            >
                                <Bed className='h-6 w-6 text-white sm:h-7 sm:w-7' />
                            </Button>
                        </motion.div>
                        <motion.div
                            initial={{ scale: 0, opacity: 0 }}
                            animate={{
                                scale: 1,
                                opacity: 1,
                                y: -100,
                            }}
                            exit={{ scale: 0, opacity: 0 }}
                            transition={{ duration: 0.2, delay: 0.05 }}
                            className='absolute bottom-6 right-6 sm:bottom-8 sm:right-8'
                        >
                            <Button
                                size='lg'
                                className='h-14 w-14 rounded-full bg-red-500 p-0 shadow-lg hover:bg-red-600 sm:h-16 sm:w-16'
                                onClick={handleGroomingReservation}
                            >
                                <ScissorsIcon className='h-6 w-6 text-white sm:h-7 sm:w-7' />
                            </Button>
                        </motion.div>
                        <motion.div
                            initial={{ scale: 0, opacity: 0 }}
                            animate={{
                                scale: 1,
                                opacity: 1,
                                x: -100,
                            }}
                            exit={{ scale: 0, opacity: 0 }}
                            transition={{ duration: 0.2, delay: 0.1 }}
                            className='absolute bottom-6 right-6 sm:bottom-8 sm:right-8'
                        >
                            <Button
                                size='lg'
                                className='h-14 w-14 rounded-full bg-green-500 p-0 shadow-lg hover:bg-green-600 sm:h-16 sm:w-16'
                                onClick={handleCall}
                            >
                                <Phone className='h-6 w-6 text-white sm:h-7 sm:w-7' />
                            </Button>
                        </motion.div>
                    </>
                )}
            </AnimatePresence>
            <motion.div animate={{ rotate: isOpen ? 135 : 0 }} transition={{ duration: 0.2 }}>
                <Button
                    size='lg'
                    className='h-14 w-14 rounded-full bg-orange-500 p-0 shadow-lg hover:bg-orange-600 sm:h-16 sm:w-16'
                    onClick={() => setIsOpen(!isOpen)}
                >
                    <Plus className='h-6 w-6 text-white sm:h-7 sm:w-7' />
                </Button>
            </motion.div>
        </div>
    )
}
